import React from 'react'
import { useNavigate } from "react-router-dom";
import { FaExclamationCircle } from 'react-icons/fa';  // Importing a specific icon for fraud alerts
import fraud from "../assets/Img/FraudImage.webp";

const fraudAlerts = [
    { Name: "List of Unregistered Agencies against which Grievances Received", link: "https://emigrate.gov.in/#/emigrate/recruiting-agent/list-of-unregistered-ra-agencies-or-agents" },
    { Name: "Advisory for Indian Nationals - Fake Job Offers in Thailand", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20for%20Indian%20Nationals_Fake%20Job%20Offers%20in%20Thailand.jpg" },
    { Name: "Advisory regarding fake job racket targeting Indian youth", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20May24.pdf" },
    { Name: "Advisory for Indian Nationals travelling to Laos & Cambodia", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20for%20Indian%20Nationals%20travelling%20to%20Laos%20&%20Cambodia.jpg" },
    { Name: "Advisory for Indian Nationals - Fake Job Offers in Laos", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Advisory%20for%20Indian%20Nationals_Fake%20Job%20Offers%20in%20Laos.jpg" },
    { Name: "Advisory regarding fake job offers in the Netherlands", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Fake%20jobs%20Advisory%20-%20Netherlands.pdf" },
    { Name: "नीदरलैंड में फर्जी नौकरी प्रदान करने के संदर्भ में जारी परामर्श", link: "https://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Fake%20jobs%20Advisory%20-%20Netherlands%20(Hindi).pdf" },
    { Name: "Advisory for job seekers in Cambodia and SEA about fake jobs involving cyber crimes", link: "http://emigrate.gov.in/assets/pdfs/staticdocuments/fra/Fraud%20alert%20-%20Phnom%20Penh.pdf" }
];

function FraudAlerts() {
    const navigate = useNavigate();
    return (
        <>
            {/* Fraud Alerts Section */}
            <div className=' rounded-xl shadow-xl bg-gray-50'>
                <h2 className="text-4xl font-bold text-red-600 text-center p-4">
                    ⚠️Fraud <span className="text-4xl font-extrabold text-gray-600">Alerts</span>
                </h2>

                <div className="pl-4 grid grid-cols-1 md:grid-cols-2">
                    <div className="text-gray-800">

                        <div className="max-h-96 overflow-y-auto mt-4 border-l-4 border-r-4 border-red-600 p-6 rounded-lg transition-transform transform ease-in-out duration-300">
                            {fraudAlerts.map((alert, i) => (
                                <div
                                    key={i}
                                    className="flex items-start space-x-3 py-3 hover:bg-blue-100 rounded-lg transition-all duration-200 ease-in-out"
                                >
                                    <FaExclamationCircle className="text-red-400 text-2xl" />
                                    <p className="text-gray-800 text-lg cursor-pointer hover:text-blue-600" >
                                        <a href={alert.link} target='blank'>
                                            {alert.Name}
                                        </a>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Image Section with Animation */}
                    <div className="flex justify-center items-center mt-6 md:mt-0">
                        <img
                            src={fraud}
                            alt="Fraud Alert"
                            width="400"
                            height="400"
                            loading="lazy"
                            decoding="async"
                            className="w-full max-w-md h-auto rounded-lg transform transition-transform duration-500 ease-in-out"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default FraudAlerts;
